import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSafetySystemFlag } from '../../hooks/useSafetySystemEnabled';

/**
 * Release gate for the Safety System routes (/safety/hub, /safety/units): the pages
 * render only when the backend SAFETY_SYSTEM_ENABLED flag is on. While the flag is
 * still unresolved nothing renders (so a direct load does not bounce), and when it
 * is off the route redirects to the Safety landing page — mirroring the backend,
 * where the endpoints 404 until release.
 */
export default function SafetyRouteGate({ children }: { children: ReactNode }) {
  const flag = useSafetySystemFlag();
  if (flag === null) return null;
  if (!flag) return <Navigate to="/safety" replace />;
  return <>{children}</>;
}
